"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFreshdeskWidget = initFreshdeskWidget;
function initFreshdeskWidget() {
    function initFreshdesk() {
        window.fdWidget.init({
            token: "01KKEFVF1BFT57VQMY78QBH2YF",
            host: "https://callxhelp.freshdesk.com",
            widgetId: "01KKEFVGY1HWTTQBGZHM5YDSHY"
        });
        setTimeout(() => {
            const frame = document.getElementById('fd_frame') || document.querySelector('[id*="fd_"]');
            if (frame) {
                frame.setAttribute('title', 'Create Tickets');
                const tooltip = document.createElement('div');
                tooltip.textContent = 'Create Tickets';
                tooltip.style.cssText = `
          position: fixed;
          bottom: 95px;
          right: 20px;
          background: rgba(0,0,0,0.8);
          color: #fff;
          padding: 6px 10px;
          border-radius: 4px;
          font-size: 12px;
          opacity: 0;
          transition: 0.3s;
          z-index: 2147483648;
        `;
                document.body.appendChild(tooltip);
                frame.addEventListener('mouseenter', () => tooltip.style.opacity = '1');
                frame.addEventListener('mouseleave', () => tooltip.style.opacity = '0');
            }
        }, 1000);
        const style = document.createElement('style');
        style.innerHTML = `
      #fd_frame {
        bottom: 20px !important;
        right: 20px !important;
        z-index: 2147483647 !important;
      }
    `;
        document.head.appendChild(style);
    }
    function initialize() {
        if (window.fdWidget) {
            initFreshdesk();
        }
        else {
            const script = document.createElement("script");
            script.src = "https://callxhelp.freshdesk.com/webchat/js/widget.js";
            script.async = true;
            script.onload = initFreshdesk;
            document.head.appendChild(script);
        }
    }
    // ✅ DIRECT CALL
    initialize();
}
window.initFreshdeskWidget = initFreshdeskWidget;
